//This loads or is given (params.year & details) : Show TaxSummary / SA302 / SaSubmission

import * as React from 'react';
import { Spinner, Text, Container, Header, Left, Body, Title } from 'native-base';
import { connect } from 'react-redux';
import CalCalDataApi from '../../api/CalCalDataApi';
import SaSubmissionContainer from './saSubmissionContainer';
import Sa302 from './sa302';
import SaNoSubmission from './saNoSubmission';
import HamburgerMenu from '../../components/hamburgerMenu';

//This is a class. Hot reload reloads the closest class up from functional components and since this is on the nav, was reloading the whole nav!
class SaDetailContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false
		};
	}

	render() {
		const { navigation, jwt, route } = this.props;
		const { params } = route;
		//console.log(params);
		const { year, details } = params;
		const { loading, loadedDetails = details } = this.state;

		if (!loading && !loadedDetails) {
			this.setState({ loading: true });
			CalCalDataApi.dataLoad('sa/' + year, jwt, res => {
				if (__DEV__) console.log(res);

				if (!res.error) this.setState({ loading: false, loadedDetails: res });
			});
		}
		__DEV__ && console.log(loadedDetails);
		//would load the details from given year if necessary (setting loading state)

		//loadedDetails = submitted, cansubmit, status(in progress, acknowledgement, response, error, not submitted)

		if (!loadedDetails)
			return (
				<Container>
					<Header>
						<Left>
							<HamburgerMenu />
						</Left>
						<Body>
							<Title>Loading</Title>
						</Body>
					</Header>
					<Text>Loading</Text>
					<Spinner />
				</Container>
			);

		if (loadedDetails.submittable || (loadedDetails.submitted && loadedDetails.status == 'waiting')) return <SaSubmissionContainer jwt={jwt} year={loadedDetails} navigation={navigation} />;
		if (loadedDetails.submitted) return <Sa302 year={year} details={loadedDetails} navigation={navigation} jwt={jwt} />;

		if (loadedDetails.submittable === false) return <SaNoSubmission year={loadedDetails} navigation={navigation} />;
		return <Spinner />;
	}
}

const mapStateToProps = state => ({
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});
export default connect(mapStateToProps)(SaDetailContainer);
